import React, { Component } from 'react';
import styles from './style.css';
import { getQuery, getUuid, setQuery } from '../utils';

class AdPause extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showItem: false,
            isRender: true,
        };
    }

    hide() {
        this.setState({
            showItem: false,
        });
    }

    show() {
        this.setState({
            showItem: true,
        });
    }

    // 曾经是隐藏成为VIP广告的方法，现在已经变成了隐藏暂停广告的方法
    adVipClose() {
        this.setState({
            showItem: false,
        });
    }

    /**
     * 曾经是用来显示成为VIP广告的方法，现在已经变成了显示暂停广告的方法
     * vip广告的默认参数：
     * {
     * url: '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip1',
     * type: 'img',
     * width: 300,
     * height: 250,
     *}
     */
    adVip({ url, type, width, height }) {
        let _adDom = null;

        if (type === 'img') {
            _adDom = <div className={styles.videoPauseContentImg} style={{ backgroundImage: `url(${url})` }} />;
        } else if (type === 'iframe') {
            const playerWidth = 300;
            const playerHeight = 250;
            const scale =
                width && height && (width > playerWidth || height > playerHeight)
                    ? Math.min(playerWidth / width, playerHeight / height)
                    : 0;
            const finalWidth = width && height ? width : '100%';
            const finalHeight = width && height ? height : '100%';
            const uuid = getUuid('pauseAd');

            if (this.handleMessage) {
                window.removeEventListener('message', this.handleMessage);
            }

            this.handleMessage = (event) => {
                if (event.data && event.data.type === 'noAd' && getQuery(event.data.url, 'parentId') === uuid) {
                    this.adVipClose();
                }
            };

            window.addEventListener('message', this.handleMessage);

            _adDom = (
                <div className={styles.videoPauseContentIframe}>
                    <div className={styles.videoPauseContentIframeContent} style={{ width: finalWidth, height: finalHeight }}>
                        <iframe
                            src={setQuery({ url, list: [{ key: 'parentId', value: uuid }] })}
                            scrolling="no"
                            frameBorder="no"
                            style={{
                                width: finalWidth,
                                height: finalHeight,
                                ...(scale > 0 ? { transform: `scale(${scale})` } : {}),
                            }}
                        />
                    </div>
                </div>
            );
        }

        this.vipChildren = _adDom;
        this.setState({
            showItem: true,
            renderVip: true,
        });
    }

    destory() {
        this.setState({
            isRender: false,
        });
    }
    componentDidMount() {
        this.pauseClose = this.refs['pauseClose'];
        this.pauseClose.onclick = () => {
            this.setState({
                showItem: false,
            });
        };
    }
    render() {
        const { isRender, showItem, renderVip } = this.state;

        return isRender ? (
            <div
                style={{ display: showItem ? 'block' : 'none' }}
                className={styles.videopause}
                id="js_videopause_container">
                <div className={styles.videoPauseLayout}>
                    <div className={styles.videoPausePosition}>
                        <a
                            href="javascript:void(0)"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.videoPauseContent}
                            ref={(c) => {
                                this.pauseLink = c;
                            }}
                            data-tag="pauselink">
                            {renderVip ? this.vipChildren : null}
                        </a>
                        <a
                            href="javascript:void(0)"
                            className={styles.videoPauseClose}
                            ref="pauseClose"
                            data-tag="pauseclose">
                            <span className={styles.videoPauseCloseIcon} />
                            <span className={styles.videoPauseCloseText} ref="pauseClose">
                                关闭广告
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default AdPause;
